/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    var Site = /** @class */ (function () {
        function Site() {
        }
        Site.init = function () {
            new Site().run();
        };
        Site.prototype.run = function () {
            Site.initResponsiveVideo();
            Site.initResponsiveTables();
            Site.initFrontpage();
            Site.initStickyHeader();
            if (window.innerWidth < 768) {
                Site.initOwlCarousel('.news__box.popular .news__list', {
                    loop: false,
                    dots: false,
                    margin: 20,
                    responsive: {
                        0: {
                            items: 1,
                        },
                        768: {
                            items: 1,
                        },
                    }
                });
            }
        };
        Site.initOwlCarousel = function (id, options) {
            var $owl = $(id);
            if ($owl.length > 0) {
                $owl.addClass('owl-carousel');
                $owl.owlCarousel(options);
            }
        };
        Site.is = function (bodyClass) {
            return document.body.classList.contains(bodyClass);
        };
        Site.initResponsiveVideo = function () {
            var iframes = document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]');
            Array.prototype.forEach.call(iframes, function (el) {
                var videoWrapper = document.createElement('div');
                videoWrapper.classList.add('video');
                videoWrapper.style.maxWidth = el.width;
                var responsiveWrapper = document.createElement('div');
                responsiveWrapper.classList.add('embed-responsive', 'embed-responsive-16by9');
                el.parentNode.insertBefore(responsiveWrapper, el);
                responsiveWrapper.appendChild(el);
                responsiveWrapper.parentNode.insertBefore(videoWrapper, responsiveWrapper);
                videoWrapper.appendChild(responsiveWrapper);
            });
        };
        Site.initResponsiveTables = function () {
            var tables = document.querySelectorAll('body:not(.admin) main table');
            Array.prototype.forEach.call(tables, function (el) {
                var responsiveWrapper = document.createElement('div');
                responsiveWrapper.classList.add('table-responsive');
                el.parentNode.insertBefore(responsiveWrapper, el);
                responsiveWrapper.appendChild(el);
            });
        };
        Site.initFrontpage = function () {
            if (!Site.is('frontpage')) {
                return;
            }
        };
        Site.initStickyHeader = function () {
            var header = document.querySelector('header');
            var sticky = header.offsetTop;
            document.getElementsByTagName('body')[0].onscroll = function () {
                if (window.pageYOffset > sticky) {
                    document.body.classList.add('sticky');
                }
                else {
                    document.body.classList.remove('sticky');
                }
            };
        };
        return Site;
    }());
    Site.init();

    exports.Site = Site;

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
